import DialogNew from "../../../designSystem/c-organism/dialogs/DialogNew";
import Icon from "../../../designSystem/a-atoms/icons/Icon";
import style from "./VideoPlayerDialog.module.css";

const VideoPlayerDialog = ({ show, onClose, videoUrl, videoName }) => {
  return (
    <DialogNew
      show={show}
      onClose={onClose}
      variants={["large", "noPadding"]}
      title={videoName || "Journey Recording"}
    >
      <div className={style.playerContainer}>
        {!videoUrl ? (
          <div className={style.loadingState}>
            <Icon>hourglass_empty</Icon>
            <span>Loading video...</span>
          </div>
        ) : (
          <video
            className={style.video}
            src={videoUrl}
            controls
            autoPlay
          />
        )}
      </div>
    </DialogNew>
  );
};

export default VideoPlayerDialog;
